import React from 'react';
import { useSelector } from 'react-redux';
import Header from 'components/Header';
import NavBarContainer from 'containers/NavBarContainer';
import { Link } from 'react-router-dom';
import config from 'Config';

const HeaderContainer = () => {
  const headerElements = useSelector((state) => state.headerElements);
  const account = useSelector((state) => state.account);
  const logoWrapper = account
    ? { elementType: Link, elementProps: { to: headerElements.logoRef || '/' } }
    : { elementType: 'a', elementProps: { href: config.brandWebsiteUrl, target: '_blank' } };

  return (
    <>
      <Header
        menuButton={headerElements.menu}
        backButton={headerElements.back}
        userButton={headerElements.user}
        subscriptionsButton={headerElements.subscriptions}
        logoWrapper={logoWrapper}
      />
      <NavBarContainer />
    </>
  );
};

export default HeaderContainer;
